import ApiService from './api.service'

const ContactMessageService = {
  Create(data) {
    return ApiService.post('ContactMessage/Create', data)
  },
  GetList(filter) {
    return ApiService.post('ContactMessage/GetList', filter)
  },
  Get(id) {
    return ApiService.get(`ContactMessage/Get/${id}`)
  }
}

export default ContactMessageService
